module.exports = __webpack_public_path__ + "img/logoall.844bdf8e.png";